var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoor4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#door-4_svg__a)",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5,
  width: 26,
  height: 22,
  rx: 2,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 14.25,
  width: 5,
  height: 3.5,
  rx: 1,
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 20.5,
  width: 5,
  height: 3.5,
  rx: 1,
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 8,
  width: 5,
  height: 3.5,
  rx: 1,
  fill: "#B4B4B4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "door-4_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export { SvgDoor4 as Component };